import * as React from 'react'

import { LandingPageContext } from './LandingPageContext'

export const useLandingPage = () => React.useContext(LandingPageContext)
